import React, { useEffect } from 'react';

import { DefaultColumnsProps } from 'types/services/requestService';
import ServiceDocuments from '../../../ServiceOfferedDocView/Documents';
import QuantityField, { getUnitQuantityText } from '../../QuantityField';

const DefaultColumns = (props: DefaultColumnsProps) => {
  const {
    setQuantity,
    quantity,
    details,
    // setPriceType,
    // priceType,
  } = props;
  /* NOTE: commented for now, until we implement price per hour, day and month on backend
    const pricingType = useMemo(() => getPriceType(priceType), [priceType]);
    const pricingTypes = useMemo(() => setDisabilityOfPriceType([priceType]), [priceType]); */
  useEffect(() => {
    setQuantity({ data: 1 });
  }, []);

  return (
    <div className="overview-columns">
      {/* <DataColumn label="Pricing options" className="input"> */}
      {/*  <Input.Radio */}
      {/*    onChange={({ target: { value: data } }) => setPriceType({ data })} */}
      {/*    values={pricingTypes} */}
      {/*    value={priceType} */}
      {/*    direction="horizontal" */}
      {/*  /> */}
      {/* </DataColumn> */}
      <QuantityField
        label={getUnitQuantityText(details)}
        value={quantity}
        onChange={(value) => setQuantity({ data: value! })}
      />
      <ServiceDocuments details={details} />
    </div>
  );
}

export default DefaultColumns;
